import React, { Fragment } from "react";
import { Box, List, ListItem } from "@mui/material";
import { headerNavigationConstants } from "../../constants/navigationConstants";
import { Link } from "react-router-dom";
import { AsideNavContainer, AsideNavTitle } from "./AsideNav.styled";

const AsideNav: React.FC = () => {
  // const { pathname } = useLocation();
  const categories = headerNavigationConstants.filter((x) => x.dropdown);

  return (
    <AsideNavContainer>
      {categories.map((category, index) => (
        <Box key={index} mb={3}>
          <AsideNavTitle variant="h6" gutterBottom>
            {category.title}
          </AsideNavTitle>
          <List disablePadding>
            {category.dropdown?.map((link, linkIndex) => (
              <Fragment key={linkIndex}>
                {
                  <ListItem>
                    <Link to={link.route ?? "/"}>{link.title}</Link>
                  </ListItem>
                }
              </Fragment>
            ))}
          </List>
        </Box>
      ))}
    </AsideNavContainer>
  );
};

export default AsideNav;
